import { useState } from "react";
import { Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const GoogleButton = ({ label, testid, onError }) => {
  const [busy, setBusy] = useState(false);

  const start = async () => {
    setBusy(true);
    try {
      const redirectUri = window.location.origin + "/auth/google";
      const { data } = await api.post("/auth/google/start", { redirect_uri: redirectUri });
      window.location.href = data.url;
    } catch (e) {
      onError?.(apiError(e));
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      data-testid={testid}
      onClick={start}
      disabled={busy}
      className="w-full h-11 rounded-lg border border-zinc-800 bg-white text-[#3c4043] font-medium text-sm flex items-center justify-center gap-2.5 hover:bg-[#f1f3f4] transition-colors disabled:opacity-70"
    >
      {busy ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : (
        <svg width="17" height="17" viewBox="0 0 48 48" aria-hidden>
          <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.5 2.5 30.1 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.8 6.1C12.3 13.1 17.6 9.5 24 9.5z" />
          <path fill="#4285F4" d="M46.1 24.6c0-1.6-.1-2.8-.4-4.1H24v8.1h12.5c-.3 2.1-1.6 5.2-4.6 7.3l7.6 5.9c4.5-4.2 6.6-10.3 6.6-17.2z" />
          <path fill="#FBBC05" d="M10.4 28.7a14.6 14.6 0 0 1 0-9.4l-7.8-6.1a24 24 0 0 0 0 21.6l7.8-6.1z" />
          <path fill="#34A853" d="M24 48c6.1 0 11.3-2 15.5-5.5l-7.6-5.9c-2 1.4-4.7 2.4-7.9 2.4-6.4 0-11.7-3.6-13.6-9l-7.8 6.1C6.5 42.6 14.6 48 24 48z" />
        </svg>
      )}
      {label}
    </button>
  );
};

export default GoogleButton;
